<template>
  <div>
    <BigButton v-if="isPlaying" text="Pause time-lapse" :action="stop" icon="pause" />
    <BigButton v-else text="Play time-lapse" :action="play" icon="play" />
  </div>
</template>

<script>
import BigButton from './BigButton';

export default {
  name: 'PlayButton',
  components: {
    BigButton
  },
  props: ['play', 'stop', 'isPlaying']
}
</script>



// WEBPACK FOOTER //
// src/components/PlayButton.vue